/* ============================================================
   Fiche produit : galerie (flèches + vignettes en bas),
   ajout au panier avec limite.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- galerie ---------- */
    var scene = document.querySelector('[data-galerie-scene]');
    if (scene) {
      var images = scene.querySelectorAll('[data-galerie-image]');
      var vignettes = document.querySelectorAll('[data-vignette]');
      var idx = 0;
      function montrer(i) {
        if (!images.length) return;
        idx = (i + images.length) % images.length;
        scene.classList.add('transition');
        setTimeout(function () {
          images.forEach(function (im, j) { im.classList.toggle('visually-hidden', j !== idx); });
          scene.classList.remove('transition');
        }, 180);
        vignettes.forEach(function (v, j) { v.classList.toggle('actif', j === idx); });
      }
      var prec = document.querySelector('[data-galerie-prec]');
      var suiv = document.querySelector('[data-galerie-suiv]');
      if (prec) prec.addEventListener('click', function () { montrer(idx - 1); });
      if (suiv) suiv.addEventListener('click', function () { montrer(idx + 1); });
      vignettes.forEach(function (v) {
        v.addEventListener('click', function () { montrer(+v.dataset.vignette); });
      });
    }

    /* ---------- ajout au panier (bouton principal) ---------- */
    var form = document.getElementById('form-achat');
    var btn = document.querySelector('[data-ajout-fiche]');
    if (form && btn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        btn.disabled = true;
        window.mdmAjouter(btn.dataset.variante, +btn.dataset.limite || 10, document.title.split('–')[0])
          .then(function () { btn.disabled = false; });
      });
    }
  });
})();
